var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 0H8C3.58172 0 0 3.58172 0 8V122C0 126.418 3.58172 130 8 130H122C126.418 130 130 126.418 130 122V8C130 3.58172 126.418 0 122 0Z",
    fill: "#FFE778"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5112 26C82.4458 26 84.5661 28.8236 83.7518 31.6473L75.5318 60.5625H88.6224C91.5878 60.5625 93.9846 62.9695 93.9846 65.9475C93.9846 67.5367 93.2932 69.0334 92.0948 70.0518L52.3466 103.951C51.5477 104.63 50.5336 105 49.4888 105C46.5542 105 44.4339 102.176 45.2482 99.3527L53.4682 70.4375H40.1779C37.3201 70.4375 35 68.1076 35 65.2377C35 63.7102 35.6607 62.2752 36.813 61.2877L76.6534 27.0646C77.4523 26.3703 78.4664 26 79.5112 26ZM73.9646 39.1152L46.124 63.0312H58.3542C59.5065 63.0312 60.5974 63.5713 61.3042 64.4971C62.0109 65.4229 62.226 66.6264 61.9034 67.7373L55.0201 91.9619L83.168 67.9688H70.6458C69.4935 67.9688 68.4026 67.4287 67.6958 66.5029C66.9891 65.5771 66.774 64.3736 67.0966 63.2627L73.9646 39.1152Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 79,
    fill: "white",
    transform: "translate(35 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomaction);
export default __webpack_public_path__ + "static/media/customaction.1d8d13a820336f32f0879bda95fdd950.svg";
export { ForwardRef as ReactComponent };